import { IDataflowBuildInTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataflow-format-type-metadata';
import { DatasetFormatType } from 'app/model/dataflow/dataset-settings/dataflow-dataset-settings';

import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

export const avro: IDataflowBuildInTypeMetadata = {
    type: DatasetFormatType.Avro,
    displayName: stringResources.ModelName_AvroDataset,
    icon: {
        className: 'svg-i-20x20-Avro'
    },
    settings: adfModelTypeMap.avro.dataflowSettings,
    useInlineProjection: true,
    enableImportSchemaInSink: true,
    mdfFabric: { isLakehouseFileFormat: true, order: 1 }
};

export const cdm: IDataflowBuildInTypeMetadata = {
    type: DatasetFormatType.CDM,
    displayName: stringResources.DataFlowSourcePanelCommonDataModel,
    icon: {
        className: 'svg-i-20x20-cdm'
    },
    settings: adfModelTypeMap.cdm.dataflowSettings,
    useInlineProjection: true,
    enableImportSchemaInSink: true
};

export const delimited: IDataflowBuildInTypeMetadata = {
    type: DatasetFormatType.Delimited,
    displayName: stringResources.ModelName_DelimitedTextDataset,
    icon: {
        className: 'svg-i-20x20-csv'
    },
    settings: adfModelTypeMap.delimitedText.dataflowSettings,
    useInlineProjection: true,
    enableImportSchemaInSink: true,
    mdfFabric: { isLakehouseFileFormat: true, order: 0 }
};

export const iceberg: IDataflowBuildInTypeMetadata = {
    type: DatasetFormatType.Iceberg,
    displayName: stringResources.Iceberg_DisplayText,
    icon: {
        className: 'svg-i-20x20-Iceberg'
    },
    settings: adfModelTypeMap.iceberg.dataflowSettings,
    useInlineProjection: true,
    enableImportSchemaInSink: true
};


export const delta: IDataflowBuildInTypeMetadata = {
    type: DatasetFormatType.Delta,
    displayName: stringResources.ModelName_DelaFormatDataset,
    icon: {
        className: 'svg-i-20x20-delta-lake'
    },
    settings: adfModelTypeMap.delta.dataflowSettings,
    useInlineProjection: true,
    enableImportSchemaInSink: true
};

export const excel: IDataflowBuildInTypeMetadata = {
    type: DatasetFormatType.Excel,
    displayName: stringResources.ModelName_ExcelDataset,
    icon: {
        className: 'svg-i-20x20-excel'
    },
    settings: adfModelTypeMap.excel.dataflowSettings,
    useInlineProjection: true
};

export const json: IDataflowBuildInTypeMetadata = {
    type: DatasetFormatType.Json,
    displayName: stringResources.ModelName_JsonDataset,
    icon: {
        className: 'svg-i-20x20-Json'
    },
    settings: adfModelTypeMap.json.dataflowSettings,
    useInlineProjection: true,
    enableImportSchemaInSink: true,
    mdfFabric: { isLakehouseFileFormat: true, order: 3 }
};

export const orc: IDataflowBuildInTypeMetadata = {
    type: DatasetFormatType.Orc,
    displayName: stringResources.ModelName_OrcDataset,
    icon: {
        className: 'svg-i-20x20-ORC'
    },
    settings: adfModelTypeMap.orc.dataflowSettings,
    useInlineProjection: true,
    enableImportSchemaInSink: true,
    mdfFabric: { isLakehouseFileFormat: true, order: 4 }
};

export const parquet: IDataflowBuildInTypeMetadata = {
    type: DatasetFormatType.Parquet,
    displayName: stringResources.ModelName_ParquetDataset,
    icon: {
        className: 'svg-i-20x20-Parquet'
    },
    settings: adfModelTypeMap.parquetInline.dataflowSettings,
    useInlineProjection: true,
    enableImportSchemaInSink: true,
    mdfFabric: { isLakehouseFileFormat: true, order: 2 }
};

export const xml: IDataflowBuildInTypeMetadata = {
    type: DatasetFormatType.Xml,
    displayName: stringResources.ModelName_XmlDataset,
    icon: {
        className: 'svg-i-20x20-Xml'
    },
    settings: adfModelTypeMap.xml.dataflowSettings,
    useInlineProjection: true
};
